import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';
import ListingCard from '../components/_ListingCard';
import Pager from '../../common/components/_Pager';
import OurPeopleFilterImport from './OurPeopleListingFilterJsFile';

function OurPeopleFunction({ entries, search, filters, settings }) { 
    const { items = [] } = entries || {};
	return (
        <div className="staff-profiles">
            <div className="row column">
                <OurPeopleFilterImport search={search} settings={settings} filters={filters} />
            </div>
            <div className="row">
                <div className="large-12 column">
                    {entries.totalCount === 0 && <p>Nothing Found</p>}
                    {entries.totalCount > 0 && 
                        items.map((entry, index) => <ListingCard key={entry.sys.id} entry={entry} index={index} settings={settings} />) }
                </div>
            </div>
            <div className="row column">
                {entries.totalCount > 10 && <Pager entries={entries} search={search} settings={settings} />}
            </div>
        </div>
	);
}


OurPeopleFunction.propTypes = {
    entries: PropTypes.object,
    search: PropTypes.object,
    filters: PropTypes.object,
    settings: PropTypes.object,
};

const mapStateToProps = state => ({ entries: getEntries(state), search: getSearch(state), filters: getFilters(state), settings: getSettings(state) });

export default connect(mapStateToProps)(OurPeopleFunction);